<template>
    <div class="row wrapper">
        <div class="image_login col-lg-7">
            <div class="container">
                <img src="../assets/image/login-img.png" class="login_img" alt="">
            </div>
        </div>
        <div class="login_form col-lg-5 my-auto">
            <div class="container">
                <h1 class="title">
                    Hello, <br>
                    Welcome back
                </h1>

                <div class="spacer-lg"></div>

                <div class="alert alert-info" v-if="query_param_message">{{ query_param_message }}</div>
                
                <form name="form" @submit.prevent="handleLogin">
                    <div class="form-group">
                        <div v-if="message" class="alert alert-danger" role="alert">{{message.message}}</div>
                    </div>
                    <div class="form-group">
                        <div class="input">
                            <input type="text" v-model="username" v-validate="'required'" name="username" class="form-control" placeholder="Username / Email">
                            <i class='bx bx-user'></i>
                        </div>
                        <div v-if="submitted && errors.has('username')" class="text-danger">
                            {{errors.first('username')?'Username Required':''}}
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="input">
                            <input type="password" v-model="password" v-validate="'required'" name="password" class="form-control field-password" placeholder="Password">
                            <i class='bx bx-lock'></i>
                            <div class="input-group-append show_pass">
                                <span class="input-group-text"><i @click="showPassword" class="eye-icon bi bi-eye"></i></span>
                            </div>
                        </div>
                        <div v-if="submitted && errors.has('password')" class="text-danger">
                            {{errors.first('password')?'Password Required':''}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" v-model="remember_me" id="remember_me">
                                <label class="custom-control-label" for="remember_me">Remember me</label>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="text-right mb-3">
                                <router-link to="/forgot-password" class="forgot_text text-danger text-decoration-none">Forgot password?</router-link>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn_red btn-block" :disabled="loading">
                        <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                        <img v-show="!loading" src="../assets/image/login_icon.svg" class="mr-2" alt="">
                        <span v-show="!loading">Login</span>
                    </button>
                </form>
                <div class="create_acc my-3">
                    <p class="text-secondary">Don't have an account?
                        <router-link to="/register" class="text-danger text-decoration-none">Register</router-link>
                    </p>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Login',
    data(){
        return{
            // user: new User('', ''),
            username: '',
            password: '',
            remember_me: false,
            loading: false,
            submitted: false,
            message: '',
            query_param_message : undefined
        };
    },
    computed: {
        loggedIn() {
        return this.$store.state.auth.status.loggedIn;
        }
    },
    created() {
        if(this.loggedIn){
        this.$router.push('/dash');
        }
    },
    mounted(){
        let qParams = new URLSearchParams(window.location.search)
        this.query_param_message = qParams.get('message')
    },
    methods: {
        showPassword() {
            const input = document.querySelector('.field-password')
            const show = document.querySelector('.eye-icon')
            if(input.type === 'password') {
                show.classList.remove('bi-eye')
                show.classList.add("bi-eye-slash")
                input.type = 'text'
            } else {
                show.classList.remove("bi-eye-slash")
                show.classList.add('bi-eye')
                input.type = 'password'
            }
        },
        handleLogin() {
        this.query_param_message = undefined;
        this.loading = true;
        this.submitted = true;
        this.$validator.validateAll().then(isValid => {
            if(!isValid){
                this.loading = false;
            return;
            }

            if(this.username && this.password){
                this.$store.dispatch('auth/login', {
                    username: this.username,
                    password: this.password,
                    remember_me: this.remember_me,
                })
                .then(() => {
                    this.$router.push('dash');
                    },
                    error => {
                        this.loading = false;
                        // console.log(error.response)
                        this.message = 
                        error.data || (error.response && error.response.data) ||
                        error.message ||
                        error.toString() ;

                        // console.log('error login', this.message)
                        }
                        
                    );
                }
            });
        }
    }
}
</script>

<style>
.wrapper{
    height: 100vh;
    width: 100%;
    margin-left: 0 !important;
}
.image_login{
    background: var(--bg-grey);
    display: flex;
    align-items: center;
    justify-content: center;
    /* width: 100%; */
}
.image_login img{
    width: 80%;
    display: block;
    margin: 0 auto;
}

.spacer-lg{
  height: 80px;
}

.login_form{
    padding: 40px 0;
}
.login_form .title{
    color: var(--darkGrey);
    font-weight: 700;
    text-align: left;
}
.login_form .form-group .input{
    position: relative;
}
.login_form .form-group .input .form-control{
    padding-left: 40px;
}
.login_form .form-group .input .input-group-append .input-group-text{
    background: transparent;
    border: none;
}
.login_form .form-group .input .input-group-append{
    position: absolute;
    top: 50%;
    right: 5px;
    transform: translate(0, -50%);
    width: 40px;
    height: 90%;
    font-size: 18pt;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--grey);
    background: transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: 1;
}
.form-group .input input.form-control:focus ~ i{
  color: var(--red);
}
.login_form .form-group .input i{
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
    width: 40px;
    height: 100%;
    font-size: 18pt;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--grey);
    transition: all 0.3s ease;
    z-index: 1;
}

@media(max-width: 767.98px){
    .image_login img{
        width: 80%;
        display: block;
        margin: 20px auto;
    }

    .spacer-lg{
        height: 20px;
    }

    .login_form{
        padding: 20px 0;
    }
}
</style>